import {
    FilterPage,
    SectionPage,
    FloorPage,
    FlatPage,
} from "../pages"

export const ROUTES = {
    'FILTER_PAGE': FilterPage,
    'SECTION_PAGE': SectionPage,
    'FLOOR_SELECTED_FLAT_PAGE': FloorPage,
    'FLAT_PAGE': FlatPage,
    'FLOOR_PAGE': FloorPage
};



// WEBPACK FOOTER //
// ./js/routes/index.js